import React, { useContext, useEffect, useState } from "react";
import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import ReversePDW from "../../../Components/GMS/Pdw/ReversePDW";
import PdwDownload from "../../../Components/GMS/Pdw/PdwDownload";
import Create from "../../../Components/GMS/Pdw/upload/Create";
import Update from "../../../Components/GMS/Pdw/upload/Update";
import Validate from "../../../Components/GMS/Pdw/upload/Validate";
import Label from "../../../Components/Common/components/Label";
import GMSBorderlessButton from "../../../Components/Common/components/GMSBorderlessButton";
import { toast } from "react-toastify";

import { Modal } from "react-bootstrap";
import SkeletonElement from "../../../Components/GMS/Category/Shimmer/SkeletonElement";
import { Link, useHistory } from "react-router-dom";
import PDWTracker from "../../../Components/GMS/Pdw/PDWTracker";
import GMSButton from "../../../Components/Common/components/GMSButton";

function PdwManage(props) {
  const [showPopup, setShowPopup] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [showValidatePopup, setShowValidatePopup] = useState(false);
  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);

  const modalOpen = () => setShowPopup(true);
  const modalClose = () => setShowPopup(false);

  const modalLogsOpen = () => setShowLogs(true);
  const modalLogsClose = () => setShowLogs(false);

  const modalValidateOpen = () => setShowValidatePopup(true);
  const modalValidateClose = () => setShowValidatePopup(false);

  const modalCreateOpen = () => setShowCreatePopup(true);
  const modalCreateClose = () => setShowCreatePopup(false);
  const modalUpdateOpen = () => setShowUpdatePopup(true);
  const modalUpdateClose = () => setShowUpdatePopup(false);

  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appData = useContext(AppContext);
  const history = useHistory();
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [categoriesList, setCategoriesList] = useState(null);
  const [categoryTypeList, setCategoryTypeList] = useState(null);

  useEffect(() => {
    if (appData.pm.checkPermission("gmsproducts_read")) {
      if (industryId) fetchData();
    } else {
      history.push("/workspace/module/permission/denied");
    }
  }, [industryId]);

  async function fetchData() {
    setLoading({ status: "Loading", message: "Loading Categories Details" });

    Promise.all([load_categories(), load_category_types()])
      .then((res) => {
        setLoading({ status: "Success", message: undefined });
      })
      .catch((err) => {
        setLoading({
          status: "Error",
          message: err,
        });
      });
  }

  function load_categories() {
    return new Promise(async (resolve, reject) => {
      let res = await ServiceWrapper.doGet(
        `${api_base_url}category/getbyindustryid/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (res.errorfound) reject("Error while Fetching categories details");
      if (!res.data.done) reject(res.data.message);

      const categories = await res.data.data.reduce((acc, category) => {
        (acc[category.cattype] = acc[category.cattype] || []).push(category);
        return acc;
      }, {});

      await setCategoriesList(categories);
      resolve();
    });
  }

  function load_category_types() {
    return new Promise(async (resolve, reject) => {
      let res = await ServiceWrapper.doGet(
        `${api_base_url}categorytype/getbyindustryid/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (res.errorfound) reject("Error while Fetching categories details");
      if (!res.data.done) reject(res.data.message);

      await setCategoryTypeList(res.data.data);
      resolve();
    });
  }

  return (
    <React.Fragment>
      {Loading.status === "Loading" ? (
        <div className="">
          <div className="pb-3 row ps-4 w-100 justify-content-between border-bottom ">
            <div className="col-2 ">
              <SkeletonElement type="title" />
            </div>
            <div className="col-4 d-flex justify-content-end ">
              <SkeletonElement type="title25" />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <SkeletonElement type="title25" />
            </div>
            {/* <div className="col-6 bg-info">
              <SkeletonElement type="title25" />
            </div> */}
          </div>
          <div className="mt-2 ms-2 row">
            <div className="col-8">
              <SkeletonElement type="title25" />
              <br />
              <SkeletonElement type="text" />
            </div>
            <div className="col-1">
              <SkeletonElement type="title" />
            </div>
            <div className="col-3">
              <SkeletonElement type="title" />
            </div>
          </div>

          <div className="row">&nbsp;</div>
          <div className="row">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item, index) => (
              <React.Fragment key={item.id}>
                <div className="col-sm-3">
                  <div className="form-check" style={{ marginBottom: 10 }}>
                    <SkeletonElement type="text50" />
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
          <br />
          <div className="ms-4 w-25">
            <SkeletonElement type="title25" />
          </div>
          <br />
        </div>
      ) : (
        <div
          className="container-fluid me-0"
          style={{
            paddingLeft: "0px",
            paddingRight: "0px",
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
        >
          <div
            className="overflow-hidden  align-items-center"
            style={{
              borderBottom: "1px solid #c9c9cf",
              paddingBottom: "0px",
              paddingTop: "10px",
              marginBottom: "20px",
            }}
          >
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              size="xl"
              show={showPopup}
              onHide={modalClose}
            >
              <Modal.Header>
                <div>
                  <Label
                    message={"Download Template"}
                    fontSize={0.875}
                    fontWeight="600"
                  />
                  <br />
                  <Label
                    message="Choose any category to download blank product template"
                    fontSize={0.75}
                    fontWeight="400"
                    color="#5c5f62"
                  />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="m-2">
                    <div className="row">
                      {categoriesList === null ||
                      categoriesList.length === 0 ? (
                        <div></div>
                      ) : (
                        <div className="row">
                          {categoriesList &&
                          categoryTypeList &&
                          Object.keys(categoriesList).length > 0 ? (
                            <PdwDownload
                              categoriesList={categoriesList}
                              categoryTypeList={categoryTypeList}
                              modalClose={modalClose}
                            />
                          ) : (
                            <p>No categories available to select</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              size="xl"
              show={showLogs}
              onHide={modalLogsClose}
            >
              <Modal.Header closeButton>
                <div>
                  <Label
                    message={"PDW Logs"}
                    fontSize={0.875}
                    fontWeight="600"
                  />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="m-2">
                    <div className="">
                      <PDWTracker />
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <div className="tw-ms-2" style={{ float: "left" }}>
              <Label message="PDW" fontSize={1.125} fontWeight="700" />
            </div>
            <div
              className="align-items-center d-flex"
              style={{ float: "right" }}
            >
              <GMSBorderlessButton
                name="Download Template"
                onClick={() => {
                  if (appData.pm.checkPermission("gmsproducts_read")) {
                    modalOpen();
                  } else {
                    toast.info(
                      "You don't have permission to create the products"
                    );
                  }
                }}
              />
              &nbsp;&nbsp;
              <GMSButton
                name="View Logs"
                fontSize="12px"
                onClick={() => {
                  modalLogsOpen();
                }}
              />
              &nbsp;&nbsp; &nbsp;
              <div className="mt-0 bd-highlight">
                <li
                  className="nav-item dropdown"
                  style={{ listStyleType: "none" }}
                >
                  <div role="group">
                    <button
                      id="btnGroupDrop1"
                      type="button"
                      className="button-fill"
                      style={{
                        marginRight: "6px",
                      }}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Upload
                    </button>
                    <ul
                      className="bg-white dropdown-menu"
                      aria-labelledby="btnGroupDrop1"
                      style={{ fontFamily: "Noto Sans", fontSize: "0.875rem" }}
                    >
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmsproducts_update")
                            ) {
                              modalValidateOpen();
                            } else {
                              toast.info(
                                "You don't have permission to validate the products"
                              );
                            }
                          }}
                        >
                          Validate
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmsproducts_update")
                            ) {
                              modalCreateOpen();
                            } else {
                              toast.info(
                                "You don't have permission to create the products"
                              );
                            }
                          }}
                        >
                          Create
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmsproducts_update")
                            ) {
                              modalUpdateOpen();
                            } else {
                              toast.info(
                                "You don't have permission to update the products"
                              );
                            }
                          }}
                        >
                          Update
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              </div>
              &nbsp;&nbsp;
            </div>
            <br />
            <br />
            <div className="pt-2 row" />
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showValidatePopup}
              onHide={modalValidateClose}
            >
              <Modal.Header closeButton>
                <div>
                  <Label
                    message={"Upload XLS - Validate"}
                    fontSize={0.875}
                    fontWeight="600"
                  />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="m-2">
                    <div className="row">
                      <Validate modalValidateClose={modalValidateClose} />
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showCreatePopup}
              onHide={modalCreateClose}
            >
              <Modal.Header closeButton>
                <div>
                  <Label
                    message={"Upload XLS - Create"}
                    fontSize={0.875}
                    fontWeight="600"
                  />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="m-2">
                    <div className="row">
                      <Create modalCreateClose={modalCreateClose} />
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showUpdatePopup}
              onHide={modalUpdateClose}
            >
              <Modal.Header closeButton>
                <div>
                  <Label
                    message={"Upload XLS - Update"}
                    fontSize={0.875}
                    fontWeight="600"
                  />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="m-2">
                    <div className="row">
                      <Update modalUpdateClose={modalUpdateClose} />
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>

            {Loading.status === "Success" && (
              <div>
                <ul className="nav nav-tabs" id="myTab" role="tablist"></ul>
                <div className="tab-content" id="myTabContent">
                  {/* <div className="">
                    {categoriesList && categoriesList.length > 0 ? (
                      <ReversePDW categoriesList={categoriesList} />
                    ) : (
                      <p>No categories available to select</p>
                    )}
                  </div>
                  
                  */}

                  {/* <div>
                    <PDWTracker categoriesList={categoriesList} />
                  </div> */}
                  <div>
                    {categoriesList &&
                    categoryTypeList &&
                    Object.keys(categoriesList).length > 0 ? (
                      <ReversePDW
                        categoriesList={categoriesList}
                        categoryTypeList={categoryTypeList}
                      />
                    ) : (
                      <p>No categories available to select</p>
                    )}
                  </div>

                  <div
                    className="tab-pane fade"
                    id="upload"
                    role="tabpanel"
                    aria-labelledby="upload-tab"
                  >
                    <div>
                      <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link active"
                            id="download-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#validate"
                            type="button"
                            role="tab"
                            aria-controls="validate"
                            aria-selected="true"
                          >
                            Validate
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="create-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#create"
                            type="button"
                            role="tab"
                            aria-controls="create"
                            aria-selected="false"
                          >
                            Create Products
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="update-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#update"
                            type="button"
                            role="tab"
                            aria-controls="update"
                            aria-selected="false"
                          >
                            Update Products
                          </button>
                        </li>
                      </ul>
                    </div>

                    <div className="mt-3 tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active "
                        id="validate"
                        role="tabpanel"
                        aria-labelledby="download-tab"
                      >
                        <Validate />
                      </div>
                      <div
                        className="tab-pane fade"
                        id="create"
                        role="tabpanel"
                        aria-labelledby="create-tab"
                      >
                        <Create />
                      </div>
                      <div
                        className="tab-pane fade"
                        id="update"
                        role="tabpanel"
                        aria-labelledby="update-tab"
                      >
                        <Update />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default PdwManage;